<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <h1 class="text-xl">智慧实验室授权</h1>
                <p class="text-gray">请点击下方按钮开始授权流程</p>
                <el-button type="primary" class="w-full" @click="startScan">
                    <i class="el-icon-scanner mr-2"></i>开始授权
                </el-button>
            </el-card>
        </div>
    </div>
</template>

<script>
import { qrCodeUpdate } from "@/api/common"
const request_base_path = require("../../../src/utils/base_url")
export default {
    name: "scanFace",
    data() {
        return {
            code_key: '',
            login_channel: '',//跳转方式，0:站内，1：第三方
        }
    },
    created() {
        // 获取扫码密钥
        this.code_key = this.$route.query.code_key;
        this.login_channel = this.$route.query.login_channel;
    },
    mounted(){
        console.log(this.$route.query,"打1111印",this.login_channel === '0')
        if(this.login_channel === '0'){
            this.$router.push({
                path: "/scanSide",
                query: {
                    code_key: this.$route.query.code_key,
                    login_channel: this.$route.query.login_channel,
                },
            });
        }
        this.loadObj();
    },
    methods: {
        loadObj(){
            let params = {
                code_key: this.code_key,
                code_status: 1,//二维码状态，1：已扫码未确认，2：已扫码已确认,3:已过期/失效
            }
            console.log("传递",params)
            qrCodeUpdate(params).then((response) => {

            })
            .catch((error) => {
            });
        },
        startScan() {
            // 模拟扫码操作，实际项目中可以使用二维码扫描库
            console.log('开始扫码');
            // 扫码完成后跳转到学工号输入页
            // 验证成功，跳转到成功页面
            // let str = request_base_path.pro_url + "#/sign_on"
            // location.href = request_base_path.pro_url + "sso-login?fromtype=3&redirect_url=" + encodeURIComponent(str)
            location.href = decodeURIComponent(this.$route.query.go_url);
        }
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .text-xl {
        font-size: 25px;
        color: rgb(37 99 235);
    }

    .text-gray {
        text-align: center;
        color: rgb(107 114 128);
    }

    .w-full {
        margin-top: 50px;
        width: 60%;
        background: rgb(37, 99, 235);
        height: 50px;
    }
}

/* 自定义样式 */
::v-deep .el-card__body {
    text-align: center;
}

.el-card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}
</style>